import React, { useEffect, useRef, useState } from 'react'
import Button from 'meinian-package/src/baseComponent/button'
import Space from 'baseComponent/space'
import { useAccountContext } from 'context'
import { BatchStart } from 'component'
import globalData from 'meinian-package/src/common/globalData'
import Tab from './tab'
import SampleClothingList from '../component/sampleClothingList'
import { type SearchType } from '../../../searchModal/util'
import BtnAddSampleClothing from '../component/btnAddSampleClothing'
import BtnAddFolder from '../component/btnAddFolder'
import RankAndScopeSelect, { RANK_STATUS, QUERY_TYPE } from '../component/rankAndScopeSelect'
import AdminModal from '../component/adminModal'
import FolderList from '../component/folderList'
import { useFolder } from '../hooks/useFolder'
import { useClothings } from '../hooks/useClothings'
import { Filter } from '../component/filters'
import CustomizeHeader, { CustomizeHeaderLeftDefault } from '../../../components/header/customizeHeader'

const DEFAULT_PARAMS = {
  containSubFolder: 0
}

export default () => {
  const [tab, setTab] = useState<SearchType>('sample_clothing')
  const [queryParams, setQueryParams] = useState(DEFAULT_PARAMS)
  const [folderParams, setFolderParams] = useState({
    parentId: '',
    rankStatus: RANK_STATUS.recentlyUpdated,
    queryType: QUERY_TYPE.all,
  })
  const [adminModalParams, setAdminModalParams] = useState({ visible: false, type: 'folder' })
  const { data: sampleFolder, refresh: refreshFolder } = useFolder(folderParams)
  const [filterVisible, setFilterVisible] = useState(false)
  const [isBatchMode, setIsBatchMode] = useState(false)
  const $clothingList = useRef(null)
  const [clothingTotal, setClothingTotal] = useState(0)
  const { teamInfo } = useAccountContext()
  const isAdministrator = teamInfo?.memberType === 1 || teamInfo?.memberType === 2

  const { run } = useClothings({ pageSize: 1, pageNo: 1, ...queryParams }, {
    manual: true,
    onSuccess(d) {
      setClothingTotal(d.resultCount)
    }
  })

  useEffect(() => {
    run()
  }, [queryParams])

  const options = [
    { label: '样衣', value: 'sample_clothing' as SearchType, num: clothingTotal },
    { label: '文件夹', value: 'sample_folder' as SearchType, num: sampleFolder?.resultCount || 0 }
  ]

  useEffect(() => {
    globalData.get('mn:sampleParams:containSubFolder', (val) => {
      setQueryParams(pre => ({ ...pre, containSubFolder: val }))
    }, 0)
  }, [])

  return (
    <>
      <CustomizeHeader
        hiddenSearch
        renderLeft={() => <CustomizeHeaderLeftDefault
          paths={[{
            name: '工作台',
            path: '/home/workbench/index'
          }, {
            name: '样衣管理',
            path: null
          }
          ]}
        />}
      />
      <Tab
        value={tab}
        options={options}
        onChange={(val) => {
          setTab(val as SearchType)
          run()
        }}
        rightRenderer={(val) => (<><div style={{ display: `${val === 'sample_clothing' ? 'flex' : 'none'}` }}>
          <Space size={16}>
            <Filter
              displayTextClassName="fill-grey-bg"
              onVisibleChange={(visible) => {
                setFilterVisible(visible)
                if (visible) {
                  setIsBatchMode(false)
                }
              }}
              visible={filterVisible && !isBatchMode}
              defaultParams={DEFAULT_PARAMS}
              value={queryParams}
              onChange={(value) => setQueryParams(value)}
              onCancel={() => setFilterVisible(false)}
            />
            <BatchStart
              displayTextClassName="fill-while-bg"
              onClick={() => {
                setIsBatchMode(true)
                setFilterVisible(false)
              }}
            />
            <BtnAddSampleClothing onClick={() => $clothingList?.current?.refresh()} />
          </Space>
        </div>
          <div style={{ display: `${val !== 'sample_clothing' ? 'flex' : 'none'}` }}>
            <Space size={16}>
              <RankAndScopeSelect
                scope={folderParams.queryType}
                rank={folderParams.rankStatus}
                onChange={(rank, scope) => setFolderParams({
                  parentId: '',
                  queryType: scope,
                  rankStatus: rank,
                })}
              />
              {isAdministrator && <Button
                onClick={() => {
                  setAdminModalParams({ visible: true, type: 'folder' })
                }}
              >
                权限管理
              </Button>}

              <Button
                onClick={() => {
                  setAdminModalParams({ visible: true, type: 'sample' })
                }}
              >
                共享编辑
              </Button>
              <BtnAddFolder onClick={refreshFolder} />
            </Space>
          </div>
        </>)}
      >
        {(_tab) => {
          return _tab === 'sample_clothing' ? (
            <div style={{ marginTop: '24px' }}>
              <SampleClothingList
                style={{ marginTop: `${isBatchMode && !filterVisible ? '24px' : 0}` }}
                ref={$clothingList}
                setIsBatch={setIsBatchMode}
                isBatch={isBatchMode && !filterVisible}
                params={queryParams}
              />
            </div>
          ) : (
            <FolderList refresh={refreshFolder} data={sampleFolder?.resultList ?? []} />
          )
        }}
      </Tab>
      {adminModalParams.visible && (
        <AdminModal
          type={adminModalParams.type}
          visible={adminModalParams.visible}
          onClose={() => setAdminModalParams({ visible: false, type: '' })}
          onOk={undefined}
        />
      )}
    </>
  )
}
